import axios from 'axios'
import PowerBIResource from '../containers/resourceCatalog/catalogItem/CatalogContainer.models'
import * as pbi from 'powerbi-client'
import { EmbedConfig } from '../containers/resourceCatalog/dashboard/DashBoardContainer.models'

export const getUserResources = async (bearerToken: string) => {
  const baseUrl = window.APP_CONFIG.RAAS_URI
  const response = await axios.get(baseUrl + `/powerbi/resources`, {
    headers: { Authorization: 'Bearer ' + bearerToken },
  })

  return response.data.resources as PowerBIResource
}

export const getResourceEmbedConfig = async (
  resourceId: string,
  bearerToken: string
) => {
  const baseUrl = window.APP_CONFIG.RAAS_URI
  const hourInMilliseconds = 60 * 60 * 1000
  const response = await axios.get(
    baseUrl + `/powerbi/resources/` + resourceId,
    {
      headers: { Authorization: 'Bearer ' + bearerToken },
    }
  )

  const data = response.data
  return {
    accessToken: data.accessToken,
    tokenType: pbi.models.TokenType.Embed,
    embedUrl: data.embedUrl,
    id: data.id,
    type: data.type.toLowerCase(),
    resourceName: data.resourceName ?? 'Power BI Dashboard',
    expiration: data.expiration ?? Date.now() + hourInMilliseconds,
  } as EmbedConfig
}
